/**
 * Client-side mirrors of the server upload rules (UploadStoryMediaCommand / StoryMediaContentTypes),
 * shared by the upload fields and the form copy so the hints can't drift from what is enforced.
 */

/** Mirrors the server allowlist — the picker's accept attr uses the same list. */
export const ACCEPTED_IMAGE_TYPES: ReadonlyArray<string> = [
  "image/png",
  "image/jpeg",
  "image/webp",
];

/** Mirrors the server allowlist — the picker's accept attr uses the same list. */
export const ACCEPTED_VIDEO_TYPES: ReadonlyArray<string> = [
  "video/mp4",
  "video/webm",
  "video/quicktime",
];

/** Mirrors the server cap — saves a guaranteed-to-fail round trip. */
export const MAX_IMAGE_FILE_SIZE_MB = 5;

/** Mirrors the server cap — saves a guaranteed-to-fail round trip. */
export const MAX_VIDEO_FILE_SIZE_MB = 50;

/** Client-side duration cap; the server enforces only type/size (no media probing in the PoC). */
export const MAX_VIDEO_DURATION_SECONDS = 30;

const MIME_TYPE_LABELS: Record<string, string> = {
  "image/png": "PNG",
  "image/jpeg": "JPG",
  "image/webp": "WebP",
  "video/mp4": "MP4",
  "video/webm": "WebM",
  "video/quicktime": "MOV",
};

/** Human-readable list of the accepted formats, e.g. "PNG, JPG, WebP". */
export const formatAcceptedTypes = (types: ReadonlyArray<string>): string =>
  types.map((type) => MIME_TYPE_LABELS[type] ?? type).join(", ");
